export const emojis = ["👍", "❤", "😂", "😡"];
